/* CHOZEN mobile navigation drawer: drill-down levels, back, close, focus management, scroll lock.
   2026-11-02: below 1000px the drawer is NOT used any more - the original theme sidebar opens (identical to the live site).
   The drawer code is kept but only intercepts the trigger if window.__chozenMobileNavForce is set. */
(function () {
  'use strict';
  if (window.__chozenMobileNav) return;
  window.__chozenMobileNav = true;

  var MOB = window.matchMedia('(max-width:999px)');
  var root = null, panel = null, body = null, titleEl = null, backBtn = null;
  var stack = [], openers = [], lastTrigger = null, isOpen = false;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function level(id) { return id === 'root' ? $('[data-cn-lvl="root"]', root) : document.getElementById(id); }
  function focusables(scope) {
    return $$('a[href], button:not([disabled])', scope).filter(function (el) {
      return !el.closest('[hidden]') && el.getClientRects().length > 0;
    });
  }
  function find() {
    root = $('[data-chozen-mobile-nav]');
    if (!root) return false;
    if (root.parentNode !== document.body) document.body.appendChild(root);
    panel = $('.cn-panel', root); body = $('[data-cn-body]', root); titleEl = $('[data-cn-title]', root); backBtn = $('[data-cn-back]', root);
    return true;
  }

  function show(id, focus) {
    $$('.cn-lvl', root).forEach(function (l) { l.hidden = true; });
    var l = level(id); if (!l) return;
    l.hidden = false;
    titleEl.textContent = l.getAttribute('data-title') || 'תפריט';
    backBtn.hidden = stack.length < 2;
    body.scrollTop = 0;
    if (focus === 'first') { var f = focusables(l)[0]; if (f) f.focus(); }
    else if (focus && focus.focus) focus.focus();
  }
  function drill(btn) {
    var id = btn.getAttribute('data-cn-go'); if (!level(id)) return;
    stack.push(id); openers.push(btn);
    show(id, 'first');
  }
  function back() {
    if (stack.length < 2) return;
    stack.pop();
    var op = openers.pop();
    show(stack[stack.length - 1], op);
  }

  var openT = 0;
  function open(trigger) {
    if (!root && !find()) return;
    if (window.chozenMega) window.chozenMega.close(false);
    lastTrigger = trigger || null;
    stack = ['root']; openers = [];
    root.hidden = false; isOpen = true;
    root.classList.add('cn-opening'); clearTimeout(openT); openT = setTimeout(function () { if (root) root.classList.remove('cn-opening'); }, 2200);
    document.documentElement.classList.add('cn-lock');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    show('root');
    setTimeout(function () { var c = $('.cn-close', root); if (c) c.focus(); }, 30);
  }
  function close(restore) {
    if (!root || !isOpen) return;
    root.hidden = true; isOpen = false;
    clearTimeout(openT); root.classList.remove('cn-opening');
    document.documentElement.classList.remove('cn-lock');
    var t = lastTrigger; lastTrigger = null;
    if (t) { t.setAttribute('aria-expanded', 'false'); if (restore) t.focus(); }
  }

  document.addEventListener('DOMContentLoaded', find);
  if (document.readyState !== 'loading') find();

  window.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('button[aria-controls="sidebar-menu"]');
    if (!t || !MOB.matches || !window.__chozenMobileNavForce) return; /* default: original sidebar opens */
    if (!root && !find()) return;
    e.preventDefault(); e.stopImmediatePropagation();
    open(t);
  }, true);

  document.addEventListener('click', function (e) {
    if (!isOpen) return;
    if (e.target.closest('[data-cn-close]')) { close(true); return; }
    var go = e.target.closest('[data-cn-go]'); if (go) { drill(go); return; }
    if (e.target.closest('[data-cn-back]')) { back(); return; }
    if (e.target.closest('[data-cn-search]')) {
      close(false);
      var s = $('[data-chozen-search-open]');
      if (s) s.click(); else window.location.assign('/search');
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(true); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(panel); if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  }, true);

  var onChange = function () { if (!MOB.matches) close(false); };
  if (MOB.addEventListener) MOB.addEventListener('change', onChange); else MOB.addListener(onChange);
  document.addEventListener('shopify:section:unload', function () { close(false); root = null; });
  document.addEventListener('shopify:section:load', function () { root = null; });
})();
